import { render, staticRenderFns } from "./Petsview.vue?vue&type=template&id=23ea7402"
import script from "./Petsview.vue?vue&type=script&lang=js"
export * from "./Petsview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports